import { Typography } from 'antd';
import Images from 'app/assets/img';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

function PaymentResult() {
  const translations = useSelector(selectTranslations);
  return (
    <StyledStack
      direction={'column'}
      rowGap={'30px'}
      alignItem={'center'}
      padding={'60px 8px 30px 8px'}
    >
      <img src={Images.AutoDepositSuccess} alt="AutoDeposit" />
      <div>
        <Text style={{ textTransform: 'uppercase' }}>
          {translations?.['b2b.autoDeposit.success']}
        </Text>
        <StyledStack justifyContent={'center'} style={{ marginTop: 18 }}>
          <Link to="/auto-deposit">
            <StyledButton
              textColor="white"
              height="46px"
              style={{ minWidth: 207 }}
            >
              {translations?.['b2c.txt.paymentSuccess']}
            </StyledButton>
          </Link>
        </StyledStack>
      </div>
    </StyledStack>
  );
}

export default PaymentResult;

const Text = styled(Typography)`
  font-size: 20px;
  line-height: 40px;
  color: #000;
  font-weight: 600;
  text-align: center;
`;
